/**
 * Aseli Featured Teaser-Rail — desktop drag-to-scroll.
 * Snap is disabled during an active drag (otherwise cards jump card-by-card instead of
 * following the cursor); restored on release so the rail settles onto the nearest card.
 * Touch swipe stays native (runs smoothly with snap). Click-after-drag is suppressed
 * (capturing phase) so a real drag doesn't navigate the teaser link.
 * Idempotent (data-atr-bound guard) + shopify:section:load support for the theme editor.
 */
(function () {
  function initRail(root) {
    var rail = root.querySelector('[data-atr-rail]');
    if (!rail || rail.getAttribute('data-atr-bound')) return;
    rail.setAttribute('data-atr-bound', '1');

    var startX = 0;
    var startScroll = 0;
    var active = false;
    var moved = false;

    rail.addEventListener('mousedown', function (e) {
      rail.style.scrollSnapType = 'none';
      startX = e.pageX;
      startScroll = rail.scrollLeft;
      active = true;
      moved = false;
    });
    rail.addEventListener('mousemove', function (e) {
      if (!active) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = startScroll - dx;
    });
    function end() {
      active = false;
      rail.style.scrollSnapType = '';
    }
    rail.addEventListener('mouseup', end);
    rail.addEventListener('mouseleave', end);

    // Prevent native image-drag ghost.
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Suppress link navigation after a real drag (capture phase).
    rail.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('.atr').forEach(initRail);
  }
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      initRail(event.target);
    }
  });
})();
